import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ProgressMessage from 'components/Utils/ProgressMessage';
import SelectableListItem from 'components/Utils/SelectableListItem';
import NoItem from 'components/Common/NoItem';
import './style.scss';
import ResponsiveColumns from 'components/ResponsiveColumns';

const ListWithDetailsView = ({
  idField = 'id',
  listColumnName = 'List',
  detailColumnName = 'Detail',
  noDetail,
  ...props
}) => {
  function isSelected(item, selectedItem) {
    return selectedItem !== undefined && selectedItem === item[idField];
  }

  return (
    <div className="row full-width full-height list-with-details responsive-directory">
      <ResponsiveColumns
        navigateTo={props.navigateTo}
        columns={[
          {
            name: listColumnName,
            element: (
              <div className="full-height-panel underside-right-panel scroll-list list">
                <ProgressMessage topLeft={true} show={!!props.loading} />
                {props.title !== undefined && (
                  <span className="small-title padded-title">{props.title}</span>
                )}
                <MyList {...props} idField={idField} isSelected={isSelected} />
              </div>
            ),
          },
          noDetail
            ? undefined
            : {
                name: detailColumnName,
                element: (
                  <ExtendedPanel
                    item={props.items.find((item) => isSelected(item, props.selectedItem))}
                    {...props}
                  />
                ),
              },
        ]}
      />
    </div>
  );
};

ListWithDetailsView.propTypes = {
  items: PropTypes.array.isRequired,
  renderBadge: PropTypes.func.isRequired,
  renderDetails: PropTypes.func.isRequired,
  title: PropTypes.string,
  loading: PropTypes.bool,
  addButton: PropTypes.element,
  idField: PropTypes.string,
};

const ListItems = (props) => {
  const itemRefs = React.useRef({});

  const handleKeyDown = (e, index) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const newIndex =
        e.key === 'ArrowDown'
          ? Math.min(index + 1, props.items.length - 1)
          : Math.max(index - 1, 0);
      props.selectItem(props.items[newIndex]);
      itemRefs.current[newIndex]?.focus();
    }
  };

  return (props.items || []).map((item, index) => {
    // Check if this is a category header (non-selectable item)
    const isCategoryHeader = item.isCategory === true;

    if (isCategoryHeader) {
      // Render category headers directly without SelectableListItem wrapper
      return (
        <div
          key={item[props.idField] || item.id || item.key || 'no-id'}
          className="category-header-wrapper"
        >
          {props.renderBadge(item)}
        </div>
      );
    }

    const isSelected = props.isSelected(item, props.selectedItem);
    return (
      <SelectableListItem
        key={item[props.idField] || item.id || item.key || 'no-id'}
        className="list-item"
        selected={isSelected}
        item={props.renderBadge(item)}
        onClick={() => props.selectItem(item)}
        onKeyDown={(e) => handleKeyDown(e, index)}
        tabIndex={0}
        forwardRef={(el) => (itemRefs.current[index] = el)}
      />
    );
  });
};

export const MyList = (props) => (
  <List>
    {props.addButton}
    <NoItem show={!props.loading && (props.items || []).length === 0} />
    <ListItems {...props} />
  </List>
);

const ExtendedPanel = (props) =>
  props.overrideDetails
    ? props.overrideDetails
    : props.item
    ? props.renderDetails(props.item)
    : null;

export default ListWithDetailsView;
